import { render, staticRenderFns } from "./GainCoupon.vue?vue&type=template&id=5e28f006&scoped=true"
import script from "./GainCoupon.vue?vue&type=script&lang=js"
export * from "./GainCoupon.vue?vue&type=script&lang=js"
import style0 from "./GainCoupon.vue?vue&type=style&index=0&id=5e28f006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e28f006",
  null
  
)

export default component.exports